import { render, staticRenderFns } from "./AnuncioBanner.vue?vue&type=template&id=641d0d8a"
import script from "./AnuncioBanner.vue?vue&type=script&lang=js"
export * from "./AnuncioBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports